import CounterItemModel from './CounterItemModel';

const CounterElementModel = {
  elements: [CounterItemModel],
  animationDuration: 1,
};

export default CounterElementModel;
